import AbstractCommand from "../../../../../../shared/src/ranj/app/core/AbstractCommand";
import GameEvent from "../../../../../../shared/src/ranj/app/core/GameEvent";
import GameModel from "../model/GameModel";
import SaveModel from "../model/SaveModel";
import ScenarioCommandEvent from "../../ngt/scenario/controller/ScenarioCommandEvent";
import ScenarioPlayerRegisterEvent from "../../ngt/scenario/controller/ScenarioPlayerRegisterEvent";
import NGTScenarioPlayer from "../../ngt/scenario/NGTScenarioPlayer";
import ScenarioPlayerEvent from "../../ngt/scenario/ScenarioPlayerEvent";
import SkinKeys from "../../../../../../shared/src/ranj/app/ui/SkinKeys";


export default class StartScenarioCommand extends AbstractCommand {

    /**
     * @param {soma.EventDispatcher} dispatcher 
     * @param {SaveModel} saveModel 
     * @param {GameModel} gameModel 
     */
    constructor(dispatcher, saveModel, gameModel) {
        super(dispatcher);

        this.execute = function(event) {

            this.dispatch(ScenarioCommandEvent.INITIALIZE_SCENARIOS);
            const saveGame = saveModel.getSaveGame();
            if (saveGame) {
                gameModel.elapsedTime = saveGame.elapsedTime;
                gameModel.restoredFeedbackPending = true;
                if (saveGame.completed) {
                    this.dispatch(GameEvent.COMPLETED);
                } else {
                    this._dispatcher.addEventListener(ScenarioPlayerRegisterEvent.REGISTER, this._handleScenarioPlayerRegistered);
                    this.dispatch(ScenarioCommandEvent.PLAY_SCENARIO, { scenarioId: saveGame.scenarioId, storyMemento: saveGame.storyMemento, storyVariables: saveGame.storyVariables });
                }
            } else {
                this.gotoScreen(SkinKeys.EPISODE_SELECTION_SCREEN);
            }
        };

        this._handleScenarioPlayerRegistered = function(e) {
            this._dispatcher.removeEventListener(ScenarioPlayerRegisterEvent.REGISTER, this._handleScenarioPlayerRegistered);
            //If a dialog was in progress, open it, and resume
            /**@type {NGTScenarioPlayer} */
            const scenarioPlayer = e.params.scenarioPlayer;
            const saveGame = saveModel.getSaveGame();
            if (saveGame && saveGame.dialogMemento) {
                const contentLabel = saveGame.dialogMemento.contentLabel;
                const storyNode = scenarioPlayer.getStoryNodeByContentLabel(contentLabel);
                const content = storyNode.getData();
                //Dispatch a ScenarioPlayerEvent.PUSH_DIALOG_AVAILABLE with an extra parameter: dialogMemento
                //NB: we dont check whether this is a push or pull dialog, because this project only uses push!
                this.dispatch(ScenarioPlayerEvent.PUSH_DIALOG_AVAILABLE, {
                    data: {
                        content: content,
                        contentPlayer: scenarioPlayer,
                        dialogMemento: saveGame.dialogMemento
                    }
                });
            }
        }.bind(this);
    }

}
